export const SEARCH_QUERY_KEY = "searchQuery";

export const TAG_FILTER_KEY = "tagFilter";
export const TYPE_FILTER_KEY = "typeFilter";
export const DESTINATIONS_FILTER_KEY = "destinationsFilter";
export const VISIBILITY_FILTER_KEY = "visibilityFilter";

export type VisibilityFilterOptionValues = "visible" | "hidden";

type VisibilityFilterOption = {
  label: string;
  value: VisibilityFilterOptionValues;
};

export const visibilityFilterOptions: VisibilityFilterOption[] = [
  {
    label: "Visible",
    value: "visible",
  },
  {
    label: "Hidden",
    value: "hidden",
  },
];
